import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

// Get all banners
export const getBanners = () => {
  return authClient().get(`${API}/banner?getDisabled=true`);
};

// Get banner by id
export const getBannerById = (id) => {
  return authClient().get(`${API}/banner/${id}`);
};

// Delete banner
export const deleteBanner = (id) => {
  return authClient().delete(`${API}/banner/${id}`);
};

// Create banner
export const postBanner = async (banner, selectedImage) => {
  if (selectedImage) {
    for (const lang of Object.keys(selectedImage)) {
      // Solo subir archivos si son instancias de File
      if (selectedImage[lang] && selectedImage[lang] instanceof File) {
        const response = await uploadSingleFile(selectedImage[lang], "banners");
        banner.imageUrl[lang] = response?.data?.fileURL;
      }
    }
  }
  return authClient().post(`${API}/banner`, banner);
};

// Update banner
export const updateBanner = async (id, banner, selectedImage) => {
  if (selectedImage) {
    for (const lang of Object.keys(selectedImage)) {
      // Solo subir archivos si son instancias de File
      if (selectedImage[lang] && selectedImage[lang] instanceof File) {
        const response = await uploadSingleFile(selectedImage[lang], "banners");
        banner.imageUrl[lang] = response?.data?.fileURL;
      }
    }
  }
  return authClient().put(`${API}/banner/${id}`, banner);
};

// Change status banner
export const changeStatusBanner = async (id, active) => {
  return authClient().put(`${API}/banner/change-status/${id}`, { active });
};

// Change order banner
export const changeOrderBanner = async (id, newOrder) => {
  return authClient().put(`${API}/banner/change-order/${id}`, { newOrder });
};
